var eventListeners = {};
/**
 * Add custom event listener to the element with the given event name and functions to execute when the event is triggered
 * @param element 
 * @param eventName 
 * @param functions 
 */ export var addCustomEventListener = function(element, eventName) {
    for(var _len = arguments.length, functions = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        functions[_key - 2] = arguments[_key];
    }
    var handleTooltipOpened = function handleTooltipOpened(e) {
        functions.forEach(function(func) {
            func(e);
        });
    };
    // element.addEventListener("opened.komodo.tooltip", handleTooltipOpened)
    element.addEventListener(eventName, handleTooltipOpened);
    eventListeners[eventName] = handleTooltipOpened;
};
/**
 * Remove the custom event listener from the element with the given event name
 * @param element
 * @param eventName
 */ export var removeCustomEventListener = function(element, eventName) {
    // element.removeEventListener("opened.komodo.tooltip", eventListeners["opened.komodo.tooltip"])
    element.removeEventListener(eventName, eventListeners[eventName]);
    delete eventListeners[eventName];
};
